import { combineReducers } from 'redux'

import { tokenProfile } from './token'
import { tokenStatsProfile } from './tokenStats'

export const tokensReducer = combineReducers({
  tokenProfile,
  tokenStatsProfile
})
